var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticStyle:{"margin-bottom":"3rem"},attrs:{"color":"primary","dark":"","height":"75px"}},[_c('v-img',{attrs:{"src":require("@/assets/THON_Quizzes_Logo.png"),"max-height":"75","max-width":"125","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }